import { css } from '@emotion/react'

export const liveMapOuter = () => css`
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: flex-end;
`

export const liveLegendMapOuter = () => css`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-end;
`

export const liveLegendMapInner = () => css`
  padding-right: 12px;
`
